/**
 * useCampaigns Hook - AWS API Version
 *
 * Manages campaign creation and updates via the AWS API layer.
 */

import { api } from '../lib/api';

/**
 * Creates a new campaign with associated patients
 */
export const createCampaign = async ({
  name,
  type,
  messages,
  channel,
  created_by,
  clinic_id = null,
  patientIds = [],
  send_secure = false,
  start_date = null,
}) => {
  const campaignData = {
    name,
    type,
    messages,
    channel,
    created_by,
    clinic_id,
    patient_ids: patientIds,
    send_secure,
    start_date,
    total_steps: type === 'drip' ? 3 : 1,
  };

  const result = await api.createCampaign(campaignData);

  return {
    campaign: result,
    patientCount: patientIds.length,
  };
};

/**
 * Fetches all campaigns for the current clinic
 */
export const getCampaigns = async () => {
  return api.getCampaigns();
};

/**
 * Fetches a single campaign by ID
 */
export const getCampaign = async (campaignId) => {
  return api.getCampaign(campaignId);
};

/**
 * Updates a campaign
 */
export const updateCampaign = async (campaignId, updates) => {
  return api.updateCampaign(campaignId, updates);
};

/**
 * Gets patients associated with a campaign
 */
export const getCampaignPatients = async (campaignId) => {
  return api.getCampaignPatients(campaignId);
};
